import { DestroyRef, inject } from '@angular/core';
import { ARBaseComponent } from '@relayter/core';
import { AppConstants } from '../../app.constants';
import { UserIsAllowedToPipe } from '../../pipes/user-is-allowed-to.pipe';

export abstract class RLBaseComponent extends ARBaseComponent {
    public readonly permissions = AppConstants.PERMISSIONS;
    protected readonly userIsAllowedToPipe = inject(UserIsAllowedToPipe);
    protected readonly destroyRef: DestroyRef = inject(DestroyRef);
}
